import { defineMessages } from 'react-intl'

const translations = defineMessages({
  myPayments: {
    defaultMessage: 'My Payment Methods',
    id: 'global.account.link.payment_methods'
  },
  preferredPayment: {
    defaultMessage: 'Default Payment Method',
    id: 'msp.account.payment_instrument.default_paymentInstrument'
  },
  paymentMethodRemoveTitle: {
    defaultMessage: 'Confirm deletion',
    id: 'msp.account.payment_instrument.remove.title'
  },
  paymentMethodRemoveDescription: {
    defaultMessage: 'Payment Method',
    id: 'msp.account.payment_instrument.remove.description'
  },
  paymentMethodRemoveNote: {
    defaultMessage:
      'Note: Deleting this Payment method will not cancel any pending orders. Please check and update your Darq subscriptions that are linked to this payment method to ensure future orders are properly processed.',
    id: 'msp.account.payment_instrument.remove.note'
  },
  paymentMethodRemoveCancel: {
    defaultMessage: 'Cancel',
    id: 'msp.account.payment_instrument.remove.cancel'
  },
  paymentMethodRemoveConfirm: {
    defaultMessage: 'Confirm deletion',
    id: 'msp.account.payment_instrument.remove.confirm'
  },
  placeholderHeading: {
    defaultMessage: `You don't have any saved payment methods.`,
    id: 'msp.account.payment_instrument.placeholder.no_order_yet'
  },
  placeholderText: {
    defaultMessage:
      'Once you place an order, your used payment method will be visible here.',
    id: 'msp.account.payment_instrument.placeholder.text'
  },
  placeholderCTAText: {
    defaultMessage: 'Continue Shopping',
    id: 'msp.account.payment_instrument.placeholder.cta_text'
  }
})

export default translations
